import { render, staticRenderFns } from "./team-edit.vue?vue&type=template&id=6df62871&scoped=true&"
import script from "./team-edit.vue?vue&type=script&lang=js&"
export * from "./team-edit.vue?vue&type=script&lang=js&"
import style0 from "./team-edit.vue?vue&type=style&index=0&id=6df62871&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df62871",
  null
  
)

export default component.exports